import { NEW_ROW_ID_PREFIX } from 'framework/list';
import { PlannedLeaveBatchItem, PlannedLeaveFormRow } from './types';

export const mapTeamPlannedLeavesToBatchPayload = (
  projectId: string,
  teamPlannedLeaves: PlannedLeaveFormRow[] = [],
): PlannedLeaveBatchItem[] =>
  teamPlannedLeaves
    .filter(item => !item?.['_isMarkedForDeletion'])
    .map(item => ({
      id: item?.id?.toString().startsWith(NEW_ROW_ID_PREFIX) ? null : String(item.id),
      projectId,
      employeeAlias: item.employeeAlias,
      startDate: item.startDate,
      endDate: item.endDate,
      comment: item.comment ?? null,
    }));
